/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: FFfHwcK1KldB
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  get as $stateGet,
  set as $stateSet,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebWindowManagerSurface from "../../OP1WebWindowManagerSurface"; // plasmic-import: vcRC7TdY5z6b/codeComponent
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: Utk5Dv_x15H2/component
import Op1WebFrameWindow from "../../OP1WebFrameWindow"; // plasmic-import: 3G-AdtWfG7Gm/codeComponent
import Op1WebWindowTabHead from "../../Op1WebWindowTabHead"; // plasmic-import: vtiP6mjKQi__/component
import Op1WebAw from "../../Op1WebAw"; // plasmic-import: 3h2MZU5cY1NW/component
import Op1WebDock from "../../Op1WebDock"; // plasmic-import: WsKrqHiP5PVH/component
import Op1WebAwButton from "../../Op1WebAwButton"; // plasmic-import: gNk1RWPoHev5/component
import Op1WebButtonAppWindow from "../../OP1WebButtonAppWindow"; // plasmic-import: BXxrqEh84nVD/codeComponent
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicTestPageTestAppWindow.module.css"; // plasmic-import: FFfHwcK1KldB/css
import VectorIcon from "./icons/PlasmicIcon__Vector"; // plasmic-import: 0r8GBSQVbPd5/icon
import image35HlflJTrr2H0A from "./images/image35.svg"; // plasmic-import: HlflJTrr2H0a/picture
import image73Ej7HXzcFMlt0 from "./images/image73.svg"; // plasmic-import: ej7HXzcFMlt0/picture
import userFocusUhzXeSlJfh4K from "./images/userFocus.svg"; // plasmic-import: uhzXeSlJfh4K/picture
import logo256PxYwIRv7DkmG2 from "./images/logo256Px.svg"; // plasmic-import: ywI_Rv7DkmG2/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicTestPageTestAppWindow__VariantProps = new Array();

export const PlasmicTestPageTestAppWindow__ArgProps = new Array();

const $$ = {};

function PlasmicTestPageTestAppWindow__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appWindowButton3.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "isPage2Open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "isPage1Open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => true
      },
      {
        path: "variabletttttt",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_nJ1Nn58LcfAm7wemZm71QH",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <Op1WebWindowManagerSurface
          className={classNames(
            "__wab_instance",
            sty.op1WebWindowManagerSurface__yDDrS
          )}
        >
          <div className={classNames("all", sty.freeBox__rk3H7)}>
            <ButtonPrimary
              className={classNames(
                "__wab_instance",
                sty.buttonPrimary___6GQ2U
              )}
              color={"supaLight"}
              content={"open page 2"}
              size={"small"}
              ststus={"normal"}
              windowId={"framePilot"}
            />

            <ButtonPrimary
              className={classNames(
                "__wab_instance",
                sty.buttonPrimary___5Fy1N
              )}
            />
          </div>
          {(() => {
            try {
              return $state.variabletttttt;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <Op1WebFrameWindow
              className={classNames(
                "__wab_instance",
                sty.op1WebFrameWindowPilot__qsSkw
              )}
            />
          ) : null}
          <Op1WebFrameWindow
            bodyClass={classNames({ [sty["pcls_LpsUDJdDm3tS"]]: true })}
            className={classNames(
              "__wab_instance",
              sty.op1WebFrameWindowPilot__nrrKh
            )}
            header={
              (() => {
                try {
                  return true;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return true;
                  }
                  throw e;
                }
              })() ? (
                <Op1WebWindowTabHead
                  data-plasmic-name={"op1WebWindowTabHead"}
                  data-plasmic-override={overrides.op1WebWindowTabHead}
                  appWindowIcon={{
                    src: image35HlflJTrr2H0A,
                    fullWidth: 20,
                    fullHeight: 20,
                    aspectRatio: undefined
                  }}
                  className={classNames(
                    "__wab_instance",
                    sty.op1WebWindowTabHead
                  )}
                  crumb1Title={"signup successful"}
                  onClickBackButton={async () => {
                    const $steps = {};
                    $steps["updateIsPage2Open"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["isPage2Open"]
                            },
                            operation: 0,
                            value: false
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;
                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateIsPage2Open"] != null &&
                      typeof $steps["updateIsPage2Open"] === "object" &&
                      typeof $steps["updateIsPage2Open"].then === "function"
                    ) {
                      $steps["updateIsPage2Open"] =
                        await $steps["updateIsPage2Open"];
                    }
                    $steps["updateIsPage1Open"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["isPage1Open"]
                            },
                            operation: 4
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;
                            const oldValue = $stateGet(objRoot, variablePath);
                            $stateSet(objRoot, variablePath, !oldValue);
                            return !oldValue;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateIsPage1Open"] != null &&
                      typeof $steps["updateIsPage1Open"] === "object" &&
                      typeof $steps["updateIsPage1Open"].then === "function"
                    ) {
                      $steps["updateIsPage1Open"] =
                        await $steps["updateIsPage1Open"];
                    }
                  }}
                  showBackButton={(() => {
                    try {
                      return $state.isPage2Open;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })()}
                  showCrumb1={(() => {
                    try {
                      return $state.isPage2Open;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })()}
                  showMaximizeButton={false}
                  windowTitle={"waitlist"}
                />
              ) : null
            }
            windowId={"framePilot"}
          >
            {(() => {
              try {
                return $state.isPage1Open;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return true;
                }
                throw e;
              }
            })() ? (
              <div
                data-plasmic-name={"page1"}
                data-plasmic-override={overrides.page1}
                className={classNames("all", sty.page1)}
              >
                <div
                  data-plasmic-name={"frame613"}
                  data-plasmic-override={overrides.frame613}
                  className={classNames("all", sty.frame613)}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__xv2Mu)}
                  >
                    {"waitlist signup."}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__uEyns)}
                  >
                    {
                      "By joining the o21p community you get to share your frontline insight, input and feedback, shape the future of independent practice and receive bonus credits. No obligation to adopt, use, or promote the platform and its products."
                    }
                  </div>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___0T2C8
                    )}
                  >
                    {"Fill out the form below to join the waitlist."}
                  </div>
                </div>
                <div
                  data-plasmic-name={"frame611"}
                  data-plasmic-override={overrides.frame611}
                  className={classNames("all", sty.frame611)}
                >
                  <div
                    data-plasmic-name={"frame612"}
                    data-plasmic-override={overrides.frame612}
                    className={classNames("all", sty.frame612)}
                  >
                    <div
                      data-plasmic-name={"inputField"}
                      data-plasmic-override={overrides.inputField}
                      className={classNames("all", sty.inputField)}
                    >
                      <div
                        data-plasmic-name={"frame65"}
                        data-plasmic-override={overrides.frame65}
                        className={classNames("all", sty.frame65)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__o5M66
                          )}
                        >
                          {"*"}
                        </div>
                        <div
                          data-plasmic-name={"something"}
                          data-plasmic-override={overrides.something}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.something
                          )}
                        >
                          {"first name."}
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"inputField2"}
                        data-plasmic-override={overrides.inputField2}
                        className={classNames("all", sty.inputField2)}
                      >
                        <div
                          data-plasmic-name={"text"}
                          data-plasmic-override={overrides.text}
                          className={classNames("all", "__wab_text", sty.text)}
                        >
                          {""}
                        </div>
                        <div
                          data-plasmic-name={"checkIcon"}
                          data-plasmic-override={overrides.checkIcon}
                          className={classNames("all", sty.checkIcon)}
                        >
                          <div
                            data-plasmic-name={"group"}
                            data-plasmic-override={overrides.group}
                            className={classNames("all", sty.group)}
                          >
                            {false ? (
                              <VectorIcon
                                className={classNames("all", sty.svg__wwrg4)}
                                role={"img"}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {false ? (
                        <div
                          data-plasmic-name={"frame67"}
                          data-plasmic-override={overrides.frame67}
                          className={classNames("all", sty.frame67)}
                        >
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__jgYaL
                            )}
                          >
                            {"more"}
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <div
                      data-plasmic-name={"inputField3"}
                      data-plasmic-override={overrides.inputField3}
                      className={classNames("all", sty.inputField3)}
                    >
                      <div
                        data-plasmic-name={"frame66"}
                        data-plasmic-override={overrides.frame66}
                        className={classNames("all", sty.frame66)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__sXoE6
                          )}
                        >
                          {"*"}
                        </div>
                        <div
                          data-plasmic-name={"something2"}
                          data-plasmic-override={overrides.something2}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.something2
                          )}
                        >
                          {"last name."}
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"inputField4"}
                        data-plasmic-override={overrides.inputField4}
                        className={classNames("all", sty.inputField4)}
                      >
                        <div
                          data-plasmic-name={"text2"}
                          data-plasmic-override={overrides.text2}
                          className={classNames("all", "__wab_text", sty.text2)}
                        >
                          {""}
                        </div>
                        <div
                          data-plasmic-name={"checkIcon2"}
                          data-plasmic-override={overrides.checkIcon2}
                          className={classNames("all", sty.checkIcon2)}
                        >
                          <div
                            data-plasmic-name={"group2"}
                            data-plasmic-override={overrides.group2}
                            className={classNames("all", sty.group2)}
                          >
                            {false ? (
                              <VectorIcon
                                className={classNames("all", sty.svg__txkD)}
                                role={"img"}
                              />
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {false ? (
                        <div
                          data-plasmic-name={"frame68"}
                          data-plasmic-override={overrides.frame68}
                          className={classNames("all", sty.frame68)}
                        >
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__qjUhP
                            )}
                          >
                            {"more"}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"inputField5"}
                    data-plasmic-override={overrides.inputField5}
                    className={classNames("all", sty.inputField5)}
                  >
                    <div
                      data-plasmic-name={"frame69"}
                      data-plasmic-override={overrides.frame69}
                      className={classNames("all", sty.frame69)}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text___521JW
                        )}
                      >
                        {"*"}
                      </div>
                      <div
                        data-plasmic-name={"something3"}
                        data-plasmic-override={overrides.something3}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.something3
                        )}
                      >
                        {"email."}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"inputField6"}
                      data-plasmic-override={overrides.inputField6}
                      className={classNames("all", sty.inputField6)}
                    >
                      <div
                        data-plasmic-name={"text3"}
                        data-plasmic-override={overrides.text3}
                        className={classNames("all", "__wab_text", sty.text3)}
                      >
                        {""}
                      </div>
                      <div
                        data-plasmic-name={"checkIcon3"}
                        data-plasmic-override={overrides.checkIcon3}
                        className={classNames("all", sty.checkIcon3)}
                      >
                        <div
                          data-plasmic-name={"group3"}
                          data-plasmic-override={overrides.group3}
                          className={classNames("all", sty.group3)}
                        >
                          {false ? (
                            <VectorIcon
                              className={classNames("all", sty.svg__jg3A3)}
                              role={"img"}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {false ? (
                      <div
                        data-plasmic-name={"frame70"}
                        data-plasmic-override={overrides.frame70}
                        className={classNames("all", sty.frame70)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___452Y
                          )}
                        >
                          {"more"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div
                    data-plasmic-name={"inputField7"}
                    data-plasmic-override={overrides.inputField7}
                    className={classNames("all", sty.inputField7)}
                  >
                    <div
                      data-plasmic-name={"frame71"}
                      data-plasmic-override={overrides.frame71}
                      className={classNames("all", sty.frame71)}
                    >
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__rbuTf
                        )}
                      >
                        {"*"}
                      </div>
                      <div
                        data-plasmic-name={"something4"}
                        data-plasmic-override={overrides.something4}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.something4
                        )}
                      >
                        {"where can we find more about you and/or your work?"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"inputField8"}
                      data-plasmic-override={overrides.inputField8}
                      className={classNames("all", sty.inputField8)}
                    >
                      <div
                        data-plasmic-name={"text4"}
                        data-plasmic-override={overrides.text4}
                        className={classNames("all", "__wab_text", sty.text4)}
                      >
                        {
                          "website, social media page, portfolio... enything you consider relevant."
                        }
                      </div>
                    </div>
                    {false ? (
                      <div
                        data-plasmic-name={"frame72"}
                        data-plasmic-override={overrides.frame72}
                        className={classNames("all", sty.frame72)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__gRa2E
                          )}
                        >
                          {"more"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"frame574"}
                      data-plasmic-override={overrides.frame574}
                      className={classNames("all", sty.frame574)}
                    >
                      <div
                        data-plasmic-name={"frame73"}
                        data-plasmic-override={overrides.frame73}
                        className={classNames("all", sty.frame73)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__fuil6
                          )}
                        >
                          {"*"}
                        </div>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__yWxO
                          )}
                        >
                          {"which waitlist do you want to sing up to?"}
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"checkOption"}
                        data-plasmic-override={overrides.checkOption}
                        className={classNames("all", sty.checkOption)}
                      >
                        <div
                          data-plasmic-name={"frame74"}
                          data-plasmic-override={overrides.frame74}
                          className={classNames("all", sty.frame74)}
                        >
                          <div
                            data-plasmic-name={"checkbox"}
                            data-plasmic-override={overrides.checkbox}
                            className={classNames("all", sty.checkbox)}
                          />

                          <div
                            data-plasmic-name={"elementToCheck"}
                            data-plasmic-override={overrides.elementToCheck}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.elementToCheck
                            )}
                          >
                            {"Community."}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"frame75"}
                            data-plasmic-override={overrides.frame75}
                            className={classNames("all", sty.frame75)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text___0Z47
                              )}
                            >
                              {"things"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div
                        data-plasmic-name={"checkOption2"}
                        data-plasmic-override={overrides.checkOption2}
                        className={classNames("all", sty.checkOption2)}
                      >
                        <div
                          data-plasmic-name={"frame76"}
                          data-plasmic-override={overrides.frame76}
                          className={classNames("all", sty.frame76)}
                        >
                          <div
                            data-plasmic-name={"checkbox2"}
                            data-plasmic-override={overrides.checkbox2}
                            className={classNames("all", sty.checkbox2)}
                          />

                          <div
                            data-plasmic-name={"elementToCheck2"}
                            data-plasmic-override={overrides.elementToCheck2}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.elementToCheck2
                            )}
                          >
                            {"Partnership program."}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"frame77"}
                            data-plasmic-override={overrides.frame77}
                            className={classNames("all", sty.frame77)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__xbMt
                              )}
                            >
                              {"things"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"formActions"}
                    data-plasmic-override={overrides.formActions}
                    className={classNames("all", sty.formActions)}
                  >
                    {false ? (
                      <div
                        data-plasmic-name={"globalButton"}
                        data-plasmic-override={overrides.globalButton}
                        className={classNames("all", sty.globalButton)}
                      >
                        <div
                          data-plasmic-name={"_continue"}
                          data-plasmic-override={overrides._continue}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty._continue
                          )}
                        >
                          {"go back"}
                        </div>
                      </div>
                    ) : null}
                    <ButtonPrimary
                      className={classNames(
                        "__wab_instance",
                        sty.buttonPrimary__x4TsT
                      )}
                      color={"dark"}
                      content={"next"}
                      onClick={async () => {
                        const $steps = {};
                        $steps["updateIsPage2Open"] = true
                          ? (() => {
                              const actionArgs = {
                                variable: {
                                  objRoot: $state,
                                  variablePath: ["isPage2Open"]
                                },
                                operation: 0,
                                value: true
                              };
                              return (({
                                variable,
                                value,
                                startIndex,
                                deleteCount
                              }) => {
                                if (!variable) {
                                  return;
                                }
                                const { objRoot, variablePath } = variable;
                                $stateSet(objRoot, variablePath, value);
                                return value;
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["updateIsPage2Open"] != null &&
                          typeof $steps["updateIsPage2Open"] === "object" &&
                          typeof $steps["updateIsPage2Open"].then === "function"
                        ) {
                          $steps["updateIsPage2Open"] =
                            await $steps["updateIsPage2Open"];
                        }
                        $steps["updateIsPage2Open2"] = true
                          ? (() => {
                              const actionArgs = {
                                variable: {
                                  objRoot: $state,
                                  variablePath: ["isPage1Open"]
                                },
                                operation: 4
                              };
                              return (({
                                variable,
                                value,
                                startIndex,
                                deleteCount
                              }) => {
                                if (!variable) {
                                  return;
                                }
                                const { objRoot, variablePath } = variable;
                                const oldValue = $stateGet(
                                  objRoot,
                                  variablePath
                                );
                                $stateSet(objRoot, variablePath, !oldValue);
                                return !oldValue;
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["updateIsPage2Open2"] != null &&
                          typeof $steps["updateIsPage2Open2"] === "object" &&
                          typeof $steps["updateIsPage2Open2"].then ===
                            "function"
                        ) {
                          $steps["updateIsPage2Open2"] =
                            await $steps["updateIsPage2Open2"];
                        }
                      }}
                      size={"large"}
                      ststus={"normal"}
                      type={"button"}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            {(() => {
              try {
                return $state.isPage2Open;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return true;
                }
                throw e;
              }
            })() ? (
              <div
                data-plasmic-name={"page2"}
                data-plasmic-override={overrides.page2}
                className={classNames("all", sty.page2)}
              >
                <div
                  data-plasmic-name={"frame614"}
                  data-plasmic-override={overrides.frame614}
                  className={classNames("all", sty.frame614)}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__ePVo)}
                  >
                    {"success"}
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__w3LQh)}
                  >
                    {
                      "Lorem ipsum dolor sit amet consectetur. Et etiam mattis diam sapien egestas. Feugiat fringilla scelerisque adipiscing in pulvinar tincidunt auctor curabitur fames. Feugiat tristique luctus facilisi augue orci congue hac amet rhoncus. Non mauris mattis vitae suscipit sit risus."
                    }
                  </div>
                </div>
              </div>
            ) : null}
          </Op1WebFrameWindow>
          <Op1WebWindowManagerSurface
            className={classNames(
              "__wab_instance",
              sty.op1WebWindowManagerSurface__a4UPs
            )}
          >
            <div className={classNames("all", sty.freeBox__dGwq)}>
              <ButtonPrimary
                className={classNames(
                  "__wab_instance",
                  sty.buttonPrimary__xFhJk
                )}
                color={"supaLight"}
                content={"open page 2"}
                size={"small"}
                ststus={"normal"}
                windowId={"framePilot"}
              />

              <ButtonPrimary
                className={classNames(
                  "__wab_instance",
                  sty.buttonPrimary___98Jwa
                )}
              />

              <ButtonPrimary
                className={classNames("__wab_instance", sty.buttonPrimary__eup)}
              />
            </div>
            <ButtonPrimary
              className={classNames("__wab_instance", sty.buttonPrimary__cQt3Y)}
              content={"test"}
              windowId={"framePilot"}
            />
          </Op1WebWindowManagerSurface>
          <Op1WebAw
            data-plasmic-name={"op1WebAw"}
            data-plasmic-override={overrides.op1WebAw}
            className={classNames("__wab_instance", sty.op1WebAw)}
            showBackButton={false}
          />
        </Op1WebWindowManagerSurface>
        <Op1WebDock
          data-plasmic-name={"op1WebDock"}
          data-plasmic-override={overrides.op1WebDock}
          appsWindoesGoHere={
            <React.Fragment>
              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton3"}
                data-plasmic-override={overrides.appWindowButton3}
                className={classNames("__wab_instance", sty.appWindowButton3)}
                icon={userFocusUhzXeSlJfh4K}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"conversations"}
              />

              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton4"}
                data-plasmic-override={overrides.appWindowButton4}
                className={classNames("__wab_instance", sty.appWindowButton4)}
                icon={logo256PxYwIRv7DkmG2}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"framePilot"}
              />
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.op1WebDock)}
          spacesGoHere={
            <Op1WebAwButton
              data-plasmic-name={"op1WebAwButton"}
              data-plasmic-override={overrides.op1WebAwButton}
              className={classNames("__wab_instance", sty.op1WebAwButton)}
              icon={{
                src: image73Ej7HXzcFMlt0,
                fullWidth: 20,
                fullHeight: 20,
                aspectRatio: undefined
              }}
              status={"closed"}
              windowId={"framePilot"}
            />
          }
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "page1",
    "frame613",
    "frame611",
    "frame612",
    "inputField",
    "frame65",
    "something",
    "inputField2",
    "text",
    "checkIcon",
    "group",
    "frame67",
    "inputField3",
    "frame66",
    "something2",
    "inputField4",
    "text2",
    "checkIcon2",
    "group2",
    "frame68",
    "inputField5",
    "frame69",
    "something3",
    "inputField6",
    "text3",
    "checkIcon3",
    "group3",
    "frame70",
    "inputField7",
    "frame71",
    "something4",
    "inputField8",
    "text4",
    "frame72",
    "frame574",
    "frame73",
    "checkOption",
    "frame74",
    "checkbox",
    "elementToCheck",
    "frame75",
    "checkOption2",
    "frame76",
    "checkbox2",
    "elementToCheck2",
    "frame77",
    "formActions",
    "globalButton",
    "_continue",
    "page2",
    "frame614",
    "op1WebWindowTabHead",
    "op1WebAw",
    "op1WebDock",
    "op1WebAwButton",
    "appWindowButton3",
    "appWindowButton4"
  ],

  page1: [
    "page1",
    "frame613",
    "frame611",
    "frame612",
    "inputField",
    "frame65",
    "something",
    "inputField2",
    "text",
    "checkIcon",
    "group",
    "frame67",
    "inputField3",
    "frame66",
    "something2",
    "inputField4",
    "text2",
    "checkIcon2",
    "group2",
    "frame68",
    "inputField5",
    "frame69",
    "something3",
    "inputField6",
    "text3",
    "checkIcon3",
    "group3",
    "frame70",
    "inputField7",
    "frame71",
    "something4",
    "inputField8",
    "text4",
    "frame72",
    "frame574",
    "frame73",
    "checkOption",
    "frame74",
    "checkbox",
    "elementToCheck",
    "frame75",
    "checkOption2",
    "frame76",
    "checkbox2",
    "elementToCheck2",
    "frame77",
    "formActions",
    "globalButton",
    "_continue"
  ],

  frame613: ["frame613"],
  frame611: [
    "frame611",
    "frame612",
    "inputField",
    "frame65",
    "something",
    "inputField2",
    "text",
    "checkIcon",
    "group",
    "frame67",
    "inputField3",
    "frame66",
    "something2",
    "inputField4",
    "text2",
    "checkIcon2",
    "group2",
    "frame68",
    "inputField5",
    "frame69",
    "something3",
    "inputField6",
    "text3",
    "checkIcon3",
    "group3",
    "frame70",
    "inputField7",
    "frame71",
    "something4",
    "inputField8",
    "text4",
    "frame72",
    "frame574",
    "frame73",
    "checkOption",
    "frame74",
    "checkbox",
    "elementToCheck",
    "frame75",
    "checkOption2",
    "frame76",
    "checkbox2",
    "elementToCheck2",
    "frame77",
    "formActions",
    "globalButton",
    "_continue"
  ],

  frame612: [
    "frame612",
    "inputField",
    "frame65",
    "something",
    "inputField2",
    "text",
    "checkIcon",
    "group",
    "frame67",
    "inputField3",
    "frame66",
    "something2",
    "inputField4",
    "text2",
    "checkIcon2",
    "group2",
    "frame68"
  ],

  inputField: [
    "inputField",
    "frame65",
    "something",
    "inputField2",
    "text",
    "checkIcon",
    "group",
    "frame67"
  ],

  frame65: ["frame65", "something"],
  something: ["something"],
  inputField2: ["inputField2", "text", "checkIcon", "group"],
  text: ["text"],
  checkIcon: ["checkIcon", "group"],
  group: ["group"],
  frame67: ["frame67"],
  inputField3: [
    "inputField3",
    "frame66",
    "something2",
    "inputField4",
    "text2",
    "checkIcon2",
    "group2",
    "frame68"
  ],

  frame66: ["frame66", "something2"],
  something2: ["something2"],
  inputField4: ["inputField4", "text2", "checkIcon2", "group2"],
  text2: ["text2"],
  checkIcon2: ["checkIcon2", "group2"],
  group2: ["group2"],
  frame68: ["frame68"],
  inputField5: [
    "inputField5",
    "frame69",
    "something3",
    "inputField6",
    "text3",
    "checkIcon3",
    "group3",
    "frame70"
  ],

  frame69: ["frame69", "something3"],
  something3: ["something3"],
  inputField6: ["inputField6", "text3", "checkIcon3", "group3"],
  text3: ["text3"],
  checkIcon3: ["checkIcon3", "group3"],
  group3: ["group3"],
  frame70: ["frame70"],
  inputField7: [
    "inputField7",
    "frame71",
    "something4",
    "inputField8",
    "text4",
    "frame72"
  ],

  frame71: ["frame71", "something4"],
  something4: ["something4"],
  inputField8: ["inputField8", "text4"],
  text4: ["text4"],
  frame72: ["frame72"],
  frame574: [
    "frame574",
    "frame73",
    "checkOption",
    "frame74",
    "checkbox",
    "elementToCheck",
    "frame75",
    "checkOption2",
    "frame76",
    "checkbox2",
    "elementToCheck2",
    "frame77"
  ],

  frame73: ["frame73"],
  checkOption: [
    "checkOption",
    "frame74",
    "checkbox",
    "elementToCheck",
    "frame75"
  ],

  frame74: ["frame74", "checkbox", "elementToCheck"],
  checkbox: ["checkbox"],
  elementToCheck: ["elementToCheck"],
  frame75: ["frame75"],
  checkOption2: [
    "checkOption2",
    "frame76",
    "checkbox2",
    "elementToCheck2",
    "frame77"
  ],

  frame76: ["frame76", "checkbox2", "elementToCheck2"],
  checkbox2: ["checkbox2"],
  elementToCheck2: ["elementToCheck2"],
  frame77: ["frame77"],
  formActions: ["formActions", "globalButton", "_continue"],
  globalButton: ["globalButton", "_continue"],
  _continue: ["_continue"],
  page2: ["page2", "frame614"],
  frame614: ["frame614"],
  op1WebWindowTabHead: ["op1WebWindowTabHead"],
  op1WebAw: ["op1WebAw"],
  op1WebDock: [
    "op1WebDock",
    "op1WebAwButton",
    "appWindowButton3",
    "appWindowButton4"
  ],

  op1WebAwButton: ["op1WebAwButton"],
  appWindowButton3: ["appWindowButton3"],
  appWindowButton4: ["appWindowButton4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTestPageTestAppWindow__ArgProps,
          internalVariantPropNames: PlasmicTestPageTestAppWindow__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTestPageTestAppWindow__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTestPageTestAppWindow";
  } else {
    func.displayName = `PlasmicTestPageTestAppWindow.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicTestPageTestAppWindow = Object.assign(
  // Top-level PlasmicTestPageTestAppWindow renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    page1: makeNodeComponent("page1"),
    frame613: makeNodeComponent("frame613"),
    frame611: makeNodeComponent("frame611"),
    frame612: makeNodeComponent("frame612"),
    inputField: makeNodeComponent("inputField"),
    frame65: makeNodeComponent("frame65"),
    something: makeNodeComponent("something"),
    inputField2: makeNodeComponent("inputField2"),
    text: makeNodeComponent("text"),
    checkIcon: makeNodeComponent("checkIcon"),
    group: makeNodeComponent("group"),
    frame67: makeNodeComponent("frame67"),
    inputField3: makeNodeComponent("inputField3"),
    frame66: makeNodeComponent("frame66"),
    something2: makeNodeComponent("something2"),
    inputField4: makeNodeComponent("inputField4"),
    text2: makeNodeComponent("text2"),
    checkIcon2: makeNodeComponent("checkIcon2"),
    group2: makeNodeComponent("group2"),
    frame68: makeNodeComponent("frame68"),
    inputField5: makeNodeComponent("inputField5"),
    frame69: makeNodeComponent("frame69"),
    something3: makeNodeComponent("something3"),
    inputField6: makeNodeComponent("inputField6"),
    text3: makeNodeComponent("text3"),
    checkIcon3: makeNodeComponent("checkIcon3"),
    group3: makeNodeComponent("group3"),
    frame70: makeNodeComponent("frame70"),
    inputField7: makeNodeComponent("inputField7"),
    frame71: makeNodeComponent("frame71"),
    something4: makeNodeComponent("something4"),
    inputField8: makeNodeComponent("inputField8"),
    text4: makeNodeComponent("text4"),
    frame72: makeNodeComponent("frame72"),
    frame574: makeNodeComponent("frame574"),
    frame73: makeNodeComponent("frame73"),
    checkOption: makeNodeComponent("checkOption"),
    frame74: makeNodeComponent("frame74"),
    checkbox: makeNodeComponent("checkbox"),
    elementToCheck: makeNodeComponent("elementToCheck"),
    frame75: makeNodeComponent("frame75"),
    checkOption2: makeNodeComponent("checkOption2"),
    frame76: makeNodeComponent("frame76"),
    checkbox2: makeNodeComponent("checkbox2"),
    elementToCheck2: makeNodeComponent("elementToCheck2"),
    frame77: makeNodeComponent("frame77"),
    formActions: makeNodeComponent("formActions"),
    globalButton: makeNodeComponent("globalButton"),
    _continue: makeNodeComponent("_continue"),
    page2: makeNodeComponent("page2"),
    frame614: makeNodeComponent("frame614"),
    op1WebWindowTabHead: makeNodeComponent("op1WebWindowTabHead"),
    op1WebAw: makeNodeComponent("op1WebAw"),
    op1WebDock: makeNodeComponent("op1WebDock"),
    op1WebAwButton: makeNodeComponent("op1WebAwButton"),
    appWindowButton3: makeNodeComponent("appWindowButton3"),
    appWindowButton4: makeNodeComponent("appWindowButton4"),
    // Metadata about props expected for PlasmicTestPageTestAppWindow
    internalVariantProps: PlasmicTestPageTestAppWindow__VariantProps,
    internalArgProps: PlasmicTestPageTestAppWindow__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/page-test-AppWindow",
      pagePath: "/page-test-AppWindow",
      params: {},
      query: {}
    })
  }
);

export default PlasmicTestPageTestAppWindow;
/* prettier-ignore-end */
